"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipPosition = void 0;
/**
 * Positioned relative to the set, without going outside the container.
 */
var getTooltipPosition = function (tooltip, container, set) {
    var tooltipWidth = tooltip.getBoundingClientRect().width;
    var _a = container.getBoundingClientRect(), _b = _a.x, containerLeft = _b === void 0 ? 0 : _b, containerWidth = _a.width;
    var _c = set.getBoundingClientRect(), _d = _c.x, setLeft = _d === void 0 ? 0 : _d, setWidth = _c.width;
    var setCentre = setLeft - containerLeft + setWidth / 2;
    var leftBoundary = setCentre - tooltipWidth / 2;
    var rightBoundary = setCentre + tooltipWidth / 2;
    var position = 
    // If tooltip would appear outside right edge.
    rightBoundary > containerWidth
        ? containerWidth - tooltipWidth
        : leftBoundary;
    // If tooltip would appear outside left edge.
    return position < 0 ? 0 : position;
};
exports.getTooltipPosition = getTooltipPosition;
